import {Utils} from "./Utils";

export interface LazyLoadingConfig {
    names: {
        list: string;
        items: string;
        paging: string;
    };
    wrapper: HTMLElement;
}

export class LazyLoading {
    private names: {
        list: string;
        items: string;
        paging: string;
    };
    private readonly wrapper: HTMLElement;
    private readonly list: HTMLElement;
    private paging: HTMLElement;
    protected loadClass: string = `is-loading`;
    protected watcher: () => void;

    constructor(options: LazyLoadingConfig) {
        this.names = options.names;
        this.wrapper = options.wrapper;

        this.list = this.wrapper.querySelector(`.${this.names.list}`);
        this.init();
    }

    protected scrollHandler(): void {
        this.paging = document.querySelector(`.${this.names.paging}`);

        if (this.paging) {
            const posTop = this.paging.getBoundingClientRect().top;

            if (posTop < window.innerHeight) {
                this.stopWatcher();
                this.loadNextPage();
            }
        } else {
            this.stopWatcher();
        }

    }

    public loadNextPage(): void {
        const getNextUrl = () => {
            let
                nextPage = this.paging.querySelector(`.selected`).nextElementSibling,
                result: boolean | string = false;

            if (nextPage) {
                result = nextPage.querySelector(`a`).getAttribute(`href`);
            }
            return result;
        };

        const showLoad = () => {
            const template = `
                <div class="icon-spin__wrapper">
                    <svg class="icon-spin" viewBox="0 0 50 50" width="25" height="25">
                        <circle class="icon-spin__path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                    </svg>
                    <p class="spinner__text">${this.getLoadingText()}</p>
                </div>
            `;

            this.paging.classList.add(this.loadClass);
            this.paging.insertAdjacentHTML('beforeend', template);
        };

        let nextPageUrl = getNextUrl();

        if (nextPageUrl) {
            const addPageContent = (text: string) => {
                const html = new DOMParser().parseFromString(text, "text/html");
                const items = html.querySelectorAll(`.${this.names.items}`);
                const paging = html.querySelector(`.${this.names.paging}`);

                items.forEach(item => {
                    this.list.append(item);
                });

                this.paging.after(paging);
                this.paging.remove();

                this.addWatcher();
            };

            showLoad();

            fetch(nextPageUrl)
                .then(response => {return response.text()})
                .then(text => addPageContent(text))
                .catch(error => console.error('Error:', error));
        }
    }

    public getLoadingText(): string {
        return (Utils.getLang() === `ru_ru`) ? `Загрузка ...` : `Loading ...`;
    }

    protected addWatcher(): void {
        window.addEventListener(`scroll`, this.watcher);
    }

    protected stopWatcher(): void {
        window.removeEventListener(`scroll`, this.watcher);
    }

    protected init(): void {
        if (!this.wrapper) return;

        this.watcher = () => this.scrollHandler();
        this.addWatcher();
    }
}